/**
 * CfssIncidentPage — Incident Reporting
 *
 * MN 256B.0659: Reporting requirements for CFSS
 * Thin wrapper around shared IncidentReportPage with CFSS config.
 *
 * Route: /cfss/incidents
 */

import { IncidentReportPage } from '@/pages/shared-services';

export function CfssIncidentPage() {
  return (
    <IncidentReportPage
      title="Incident Reports"
      subtitle="Report safety concerns and incidents"
      incidentTypes={[
        { value: 'injury', label: 'Injury' },
        { value: 'fall', label: 'Fall' },
        { value: 'medication_error', label: 'Medication Error' },
        { value: 'behavioral', label: 'Behavioral Concern' },
        { value: 'safety', label: 'Safety Concern' },
        { value: 'equipment', label: 'Equipment Issue' },
        { value: 'other', label: 'Other' },
      ]}
      scope="incident:report"
    />
  );
}

export default CfssIncidentPage;
